<template>
  <!-- start portfolio -->
  <div id="portfolio">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <h2 class="wow bounce">
            Printer Counters Certification
            in cooperation with
            our Partners:
          </h2>
          <div class="iso-section wow fadeIn" data-wow-delay="0.6s">
            <div class="iso-box-section">
              <div class="iso-box-wrapper col4-iso-box">

                <div v-for="project in projects" class="iso-box graphic photoshop wallpaper col-md-3 col-sm-6 col-xs-12" style="cursor: pointer;">
                  <div class="portfolio-thumb" style="height: 100px; align-content:center; vertical-align: central;" :title="project.title">
                    <img :src="project.img" class="fluid-img" alt="portfolio img">
                    <!--<div class="portfolio-overlay">
                  <h4>{{project.title}}</h4>
                </div>-->
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
      <tryBtn></tryBtn>
    </div>
  </div>
  <!-- end portfolio -->
</template>
<script>
  import tryBtn from './tryBtn'
  export default {
    name: 'projects',
    components: { tryBtn },
    data () {
      return {
        projects: [
          {
            title: 'XEROX',
            img: '../../../static/img/partners/Xerox_2008_Logo.png'
          },
          {
            title: 'BROTHER',
            img: '../../../static/img/partners/brother-logo.png'
          },
          {
            title: 'DEVELOP',
            img: '../../../static/img/partners/develop-210x100.png'
          },
          {
            title: 'KONICA MINOLTA',
            img: '../../../static/img/partners/konica-minolta.png'
          },
          {
            title: 'LEXMARK',
            img: '../../../static/img/partners/lexmark-logo.png'
          },
          {
            title: 'TOSHIBA',
            img: '../../../static/img/partners/toshiba-logo.png'
          },
          {
            title: 'HP',
            img: '../../../static/img/partners/hp-210x100.png'
          },
          {
            title: 'KYOCERA',
            img: '../../../static/img/partners/kyocera-embedded-software.png'
          },
          {
            title: 'SAMSUNG',
            img: '../../../static/img/partners/samsung-logo.png'
          },
          {
            title: 'SHARP',
            img: '../../../static/img/partners/sharp-logo.png'
          },
          {
            title: 'RICOH',
            img: '../../../static/img/partners/ricoh.png'
          },
          {
            title: 'CANON',
            img: '../../../static/img/partners/CanonIcon.png'
          },
          {
            title: 'OKI',
            img: '../../../static/img/partners/oki-logo.png'
          },
          {
            title: 'EPSON',
            img: '../../../static/img/partners/epson-logo.png'
          }
        ]
      }
    },
    computed: {
    }
  }

</script>



// WEBPACK FOOTER //
// projects.vue?1cbce712